import React, { useContext } from 'react'
import { Flex, Box } from 'pcln-design-system'
import HotelsTonight from '../HotelsTonight/HotelsTonight'
import PromoFeatureBox from '../PromoFeatureBox'
import MobileRoadTripPromo from '../Promos/Roadtrip/MobileRoadtrip'
import Form from '../Hotels/SearchForm/Form'
import BootstrapDataContext from '../../context/BootstrapDataContext'
import { handleSubmitForHotels } from '../Hotels/SearchForm/utils'
import StyledHeading from '../StyledHeading'
import MobileHeaderWrapper from '../MobileHeaderWrapper/MobileHeaderWrapper'
import useMostRecentBooking from '../CustomHooks/useMostRecentBooking'
import CrossSell from '../CrossSell'
import ACE_KEYS from '../../constants/aceKeys'
import useFirstNameInAceContentForVIP from '../CustomHooks/useFirstNameInAceContentForVIP'
import useSEMSearchHeadline from '../CustomHooks/useSEMSearchHeadline'
import ConditionalRender from '../ConditionalRender/ConditionalRender'
import MarketingTout from '../Promos/MarketingTout/MarketingTout'

const PRIMARY_HEADING_FALLBACK = 'Find your next hotel deal'
const SECONDARY_HEADING_FALLBACK = 'Save with exclusive rates'

export default function HomeMobile() {
  const mostRecentBooking = useMostRecentBooking()
  const {
    signInStatus: { signedIn, passiveSignIn },
    customer: { firstName }
  } = useContext(BootstrapDataContext)
  const SEMHeadline = useSEMSearchHeadline('SEM_HP_HOTELS_AMENITY_HEADING')
  const isSignedIn = signedIn || passiveSignIn
  useFirstNameInAceContentForVIP(
    firstName,
    ACE_KEYS.homepage.vip.withNameHeadingKey
  )
  const defaultHeadline = SEMHeadline
    ? ''
    : ACE_KEYS.homepage.hotel.signedOutHeadingKey
  const headingVIPKey = firstName
    ? ACE_KEYS.homepage.vip.withNameHeadingKey
    : ACE_KEYS.homepage.vip.defaultHeadingKey
  const heading = isSignedIn ? headingVIPKey : defaultHeadline
  const defaultFallbackHeadline = SEMHeadline || PRIMARY_HEADING_FALLBACK
  const subHeading = isSignedIn
    ? ACE_KEYS.homepage.hotel.signedInSubHeadingKey
    : ACE_KEYS.homepage.hotel.signedOutSubHeadingKey

  return (
    <>
      <MobileHeaderWrapper selectedProductName="Hotels" />
      <Box m={3}>
        <Flex flexDirection="column" mb={3}>
          <StyledHeading
            aceContent={[heading]}
            text={defaultFallbackHeadline}
            fontSize={3}
            tag="h1"
          />
          <StyledHeading
            color="text.light"
            mt={1}
            fontSize={1}
            aceContent={[subHeading]}
            text={SECONDARY_HEADING_FALLBACK}
            tag="h2"
          />
        </Flex>
        <Form onSubmit={handleSubmitForHotels} />
        {mostRecentBooking ? (
          <CrossSell booking={mostRecentBooking} />
        ) : (
          <PromoFeatureBox />
        )}
      </Box>
      <ConditionalRender
        experimentCode="HP_CONTENTFUL_TOUT"
        variantValue="VARIANT"
        experiment={<MarketingTout />}
        original={
          <Box mx={3} mb={3}>
            <MobileRoadTripPromo />
          </Box>
        }
      />
      <Box m={3}>
        <HotelsTonight />
        <Box textAlign="center" mt={4} width={1}>
          <div id="div-gpt-ad-1544641976893-0" />
        </Box>
      </Box>
    </>
  )
}
